/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
} from './PaymentType';

/**
 * 
 * @export
 * @interface Organisation
 */
export interface Organisation {
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    baseUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    analyticsSiteId?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    adminEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organisation
     */
    readOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Organisation
     */
    enterpriseMode?: boolean;
    /**
     * 
     * @type {Array<PaymentType>}
     * @memberof Organisation
     */
    acceptedPaymentMethods?: Array<PaymentType>;
}

/**
 * Check if a given object implements the Organisation interface.
 */
export function instanceOfOrganisation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function OrganisationFromJSON(json: any): Organisation {
    return OrganisationFromJSONTyped(json, false);
}

export function OrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organisation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': json['code'],
        'name': json['name'],
        'baseUrl': !exists(json, 'baseUrl') ? undefined : json['baseUrl'],
        'analyticsSiteId': !exists(json, 'analyticsSiteId') ? undefined : json['analyticsSiteId'],
        'adminEmail': !exists(json, 'adminEmail') ? undefined : json['adminEmail'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
        'enterpriseMode': !exists(json, 'enterpriseMode') ? undefined : json['enterpriseMode'],
        'acceptedPaymentMethods': !exists(json, 'acceptedPaymentMethods') ? undefined : ((json['acceptedPaymentMethods'] as Array<any>).map(PaymentTypeFromJSON)),
    };
}

export function OrganisationToJSON(value?: Organisation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'baseUrl': value.baseUrl,
        'analyticsSiteId': value.analyticsSiteId,
        'adminEmail': value.adminEmail,
        'readOnly': value.readOnly,
        'enterpriseMode': value.enterpriseMode,
        'acceptedPaymentMethods': value.acceptedPaymentMethods === undefined ? undefined : ((value.acceptedPaymentMethods as Array<any>).map(PaymentTypeToJSON)),
    };
}

